import state from "./distributionState";
import mutations from "./distributionMutations";
import getters from "./distributionGetters";
import actions from "./distributionActions";
import integrationActions from "./integration/integrationActions";
import updateActions from "./update/updateActions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {
    ...actions,
    ...updateActions,
    ...integrationActions
  }
};
